/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import { CheckPicker, Form } from 'rsuite';
import { FormFieldSize } from 'components/Form/CustomForm/CustomForm';
import FormControlLabel from '../../../Control/FormControlLabel';
// eslint-disable-next-line import/no-unresolved
import styles from './MultiSelectFormField.module.scss';

/**
 * Renders a select picker
 */
const MultiSelectFormField = forwardRef((props: any, ref: any) => {
  const {
    required,
    size,
    name,
    helpMessage = undefined,
    label,
    data,
    className,
  } = props;

  const showRequired: boolean = required || false;

  return (
    <Form.Group
      ref={ref}
      className={[
        styles.formGroup,
        (size as FormFieldSize) === 'sm' ? styles.sm : styles.lg,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <FormControlLabel required={showRequired}>{label} </FormControlLabel>
      <div className={styles.controlWrapper}>
        <Form.Control
          className={styles.control}
          accepter={CheckPicker}
          name={name}
          data={data.picker}
          placement="bottomStart"
          searchable={data ? data.searchable || false : false}
          cleanable={false}
        />
        {helpMessage ? <Form.HelpText>{helpMessage}</Form.HelpText> : null}
      </div>
    </Form.Group>
  );
});

export default MultiSelectFormField;
